(function () {
  ViewAppointmentsController.$inject = ["API_URL", "$http", "$q", "$rootScope", "$timeout", "$sce", "$location"];
  angular.module('userApp').controller('ViewAppointmentsController', ViewAppointmentsController);

  function ViewAppointmentsController(API_URL, $http, $q, $rootScope, $timeout, $sce, $location) {}
})();